import { ErrorLogger } from "../framework/ErrorLogger";
import { tbAudio } from "./tbAudio";
import { tbLoader } from "./tbLoader";
var tbAudioSprite = /** @class */ (function () {
    function tbAudioSprite(name, mp3Name, oggName, loading) {
        this.loaded = false;
        this.audio = null;
        this.name = name;
        this.mp3Name = mp3Name;
        this.oggName = oggName;
        this.loadingMoment = loading;
        console.log("audio load moment: ", this.loadingMoment);
        tbLoader.addResource(this, this.loadingMoment, 1);
    }
    tbAudioSprite.prototype.startLoading = function (moment, location) {
        var _this = this;
        if (location === void 0) { location = ""; }
        if (this._loadPromise) {
            return this._loadPromise;
        }
        console.log("tbAudioSprite::startLoading", moment, this.mp3Name, this.oggName);
        var fnameMp3 = this.mp3Name;
        if (fnameMp3.toLowerCase().indexOf("http:") !== 0 && fnameMp3.toLowerCase().indexOf("https:") !== 0) {
            fnameMp3 = location + fnameMp3;
        }
        var fnameOgg = this.oggName;
        if (fnameOgg.toLowerCase().indexOf("http:") !== 0 && fnameOgg.toLowerCase().indexOf("https:") !== 0) {
            fnameOgg = location + fnameOgg;
        }
        tbAudio.addInactiveSources(this.name, []);
        var loadAudio = function (onDone, onFail) {
            var promise = tbAudio.loadAudioFile(_this, [fnameOgg, fnameMp3], moment);
            if (promise === undefined) {
                console.warn("loadAudioFile function did not return a promise. Skip waiting for audio to finish loading");
                onDone();
            }
            else {
                promise.then(onDone, onFail);
            }
        };
        var maxLoadRetries = 100;
        this._loadPromise = new Promise(function (resolve, reject) {
            var _this = this;
            var audioLoadingComplete = function () {
                console.log("Audio Load SUCCESS", fnameMp3, fnameOgg);
                // Send analytics event when the audio loaded after more than 1 try
                // if (retryAttempts > 1)
                // {
                // 	AnalyticsManager.assetLoadingRetryFinish(retryAttempts);
                // }
                resolve();
            };
            var retryAttempts = 1;
            var onFail = function (reason) {
                console.error(reason);
                retryAttempts++;
                if (retryAttempts < maxLoadRetries) {
                    // if (LoadManager.loadRetryReport.includes(retryAttempts))
                    // {
                    // 	AnalyticsManager.assetLoadingRetryCount(retryAttempts.toString());
                    // }
                    console.log("Audio Load FAILED::Retrying", retryAttempts);
                    loadAudio(audioLoadingComplete, onFail);
                }
                else {
                    ErrorLogger.sendError(reason);
                    // Finish loading and let the game run without audio as a fallback
                    _this.loaded = true;
                    tbAudio.usingWebAudio = false;
                    tbAudio.usingHTMLAudio = false;
                    tbAudio.audioSupported = false;
                    tbLoader.loadFailed(moment);
                    reject(reason);
                }
            };
            loadAudio(audioLoadingComplete, onFail);
        });
        return this._loadPromise;
    };
    tbAudioSprite.prototype.complete = function () {
        return this.loaded;
    };
    return tbAudioSprite;
}());
export { tbAudioSprite };
